import React, { useEffect, useState, useContext } from 'react'
import { getToolData, getGrades } from '../api/audits'
import { useUser } from '../api/auth'
import { moduleCopy } from './textCopy/textCopy.js'
import { createModuleFlaggedFeatures } from '../util/featureFlagging'
import { flaggedFeatures } from '../config'
import { capitalize, pluralize } from '../util'

const ModuleContext = React.createContext()

/** @returns {import('./types').ModuleContext} */
export function useModule() {
  return useContext(ModuleContext)
}

function Provider({ children }) {
  const [module, setModule] = useState({})
  const { user } = useUser()
  const [isDataReady, setIsDataReady] = useState(false)

  const fetchData = async () => {
    try {
      const res = await getToolData()
      res.grades = await getGrades(process.env.REACT_APP_GRADES)
      setModule(res)
      setIsDataReady(true)
    } catch (e) {
      console.warn(e)
    }
  }
  useEffect(() => {
    if (user) fetchData()

    return () => {}
  }, [user])

  const contextValue = isDataReady
    ? {
        ...module,
        textCopy: moduleCopy(module.name),
        flaggedFeatures: createModuleFlaggedFeatures(flaggedFeatures, module.name),
        loading: !isDataReady
      }
    : {
        textCopy: moduleCopy(),
        loading: !isDataReady
      }

  return <ModuleContext.Provider value={contextValue}>{children}</ModuleContext.Provider>
}

export const useModuleCopy = () => {
  const { textCopy } = useModule()
  return { textCopy, capitalize, pluralize }
}

const Module = {
  Provider,
  useModule,
  useModuleCopy
}

export default Module
